import { useMutation } from "react-query";
import internalFundsTransfer from "../services/internalFundsTransfer";

function useInternalTransfer(){
    return useMutation(["internal-funds-transfer"], internalFundsTransfer)
}

export default useInternalTransfer